/**
 * CoverMyWheel cover configurator (Shopify theme)
 * Layered preview + /cart/add.js with line item properties
 * Asset URL build: v4 (assetBase + assetQuery, Shopify ?v= safe)
 * Pricing: v7 (price variants Standard/1–5 by material surcharge total)
 */
(function () {
  const WIZARD_STEPS = [
    {
      id: 'tb-mat',
      title: 'Material choice Top & Bottom',
      short: 'Top material',
      hint: 'Choose the material type for the top and bottom of the cover.',
      info:
        'Each cover is made from four sections: top, bottom, left, and right. Here you choose the material for the Top & Bottom sections.',
    },
    {
      id: 'tb-sw',
      title: 'Top & Bottom colour',
      short: 'Top colour',
      selection: (s) => s.topBottom,
      hint: 'Pick the colour for the top and bottom.',
    },
    {
      id: 'lr-mat',
      title: 'Material choice Left & Right',
      short: 'Side material',
      hint: 'Choose the material for the left and right sides.',
      info:
        'Each cover is made from four sections: top, bottom, left, and right. Here you choose the material for the Left & Right sections.',
    },
    {
      id: 'lr-sw',
      title: 'Left & Right colour',
      short: 'Side colour',
      selection: (s) => s.leftRight,
      hint: 'Pick the colour for the sides.',
    },
    {
      id: 'marker',
      title: "12 O'Clock marker",
      short: 'Marker',
      selection: (s) => (s.markerEnabled === 'Yes' ? s.marker : 'No'),
      hint: 'A small accent strip at the top centre of the steering wheel, fully optional.',
    },
    {
      id: 'thread',
      title: 'Thread choice',
      short: 'Thread',
      selection: (s) => s.thread.name,
      hint: 'The stitching colour only, not the cover material.',
    },
    {
      id: 'car',
      title: 'Your Car',
      short: 'Your car',
      selection: (s) => {
        if (s.vehicle.trim()) return s.vehicle.trim();
        if (s.photo) return 'Photo uploaded';
        return '';
      },
      hint: '',
    },
    {
      id: 'summary',
      title: 'Your configuration',
      short: 'Review',
      hint: '',
    },
  ];

  function isMobileLayout() {
    return typeof window !== 'undefined' && window.matchMedia('(max-width: 979px)').matches;
  }

  function isBlackColorChoice(name) {
    return /\bblack\b/i.test(String(name || ''));
  }

  function appendPopularBadge(tile, name) {
    if (!isBlackColorChoice(name)) return;
    tile.appendChild(
      el('span', 'cfg-sw__popular', {
        text: 'Popular',
        title: 'Most popular option',
        'aria-label': 'Most popular option',
      })
    );
  }

  const SVG = {
    chevron:
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><polyline points="6 9 12 15 18 9"/></svg>',
    cart:
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>',
    upload:
      '<svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>',
    check:
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg>',
    close:
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
    arrowL:
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><polyline points="15 18 9 12 15 6"/></svg>',
    arrowR:
      '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><polyline points="9 18 15 12 9 6"/></svg>',
    zoom:
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>',
    info:
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"/><line x1="12" y1="11" x2="12" y2="16"/><circle cx="12" cy="8" r="0.6" fill="currentColor"/></svg>',
  };

  function el(tag, className, attrs, children) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (attrs) {
      Object.entries(attrs).forEach(([k, v]) => {
        if (k === 'text') node.textContent = v;
        else if (k === 'html') node.innerHTML = v;
        else if (k.startsWith('on') && typeof v === 'function') node.addEventListener(k.slice(2).toLowerCase(), v);
        else if (v != null) node.setAttribute(k, v);
      });
    }
    if (children != null) {
      const list = Array.isArray(children) ? children : [children];
      list.forEach((c) => {
        if (c == null) return;
        node.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
      });
    }
    return node;
  }

  const CFG_ASSET_PREFIX = 'cmw-cfg__';
  const ASSET_EXT = { value: '.png' };

  /** Keep in sync with scripts/asset-names.mjs — Shopify rejects &, ', # and spaces in asset filenames. */
  function cfgSafeSegment(part) {
    return String(part)
      .replace(/&/g, '-and-')
      .replace(/'/g, '')
      .replace(/#/g, '-')
      .replace(/\s+/g, '-')
      .replace(/[^a-zA-Z0-9._-]/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  function cfgAssetFile(...parts) {
    return CFG_ASSET_PREFIX + parts.map(cfgSafeSegment).join('__') + ASSET_EXT.value;
  }

  /**
   * Shopify asset_url returns …/file.png?v=123. Stripping the filename leaves …/assets/?v=123
   * and naive concatenation breaks: …/assets/?v=123other-file.png
   */
  function parseShopifyAssetUrl(sampleUrl) {
    const raw = String(sampleUrl || '');
    const q = raw.indexOf('?');
    const path = q === -1 ? raw : raw.slice(0, q);
    const query = q === -1 ? '' : raw.slice(q);
    const slash = path.lastIndexOf('/');
    const dir = slash >= 0 ? path.slice(0, slash + 1) : path;
    return { dir, query };
  }

  function normalizeAssetQuery(query) {
    const q = String(query || '');
    if (!q) return '';
    if (q.startsWith('?')) return q;
    if (q.startsWith('v=')) return `?${q}`;
    return `?${q}`;
  }

  function joinAssetUrl(sampleUrl, filename, assetQuery) {
    const raw = String(sampleUrl || '');
    if (raw.includes('cmw-cfg__')) {
      const { dir, query } = parseShopifyAssetUrl(raw);
      return dir + filename + query;
    }
    const query = normalizeAssetQuery(assetQuery);
    return raw + filename + query;
  }

  function cfgAssetUrl(assetBase, assetQuery, ...parts) {
    const file = CFG_ASSET_PREFIX + parts.map(cfgSafeSegment).join('__') + ASSET_EXT.value;
    return joinAssetUrl(assetBase, file, assetQuery);
  }

  /** Thumbnails are uploaded as PNG only; never switch to .webp with the preview layers. */
  function cfgThumbAssetUrl(assetBase, assetQuery, ...parts) {
    const file = CFG_ASSET_PREFIX + parts.map(cfgSafeSegment).join('__') + '.png';
    return joinAssetUrl(assetBase, file, assetQuery);
  }

  function isBackedAlcantaraColor(name) {
    return typeof name === 'string' && name.includes('Backed Alcantara');
  }

  /** Preview assets still live under Backed Alcantara/ in the source tree. */
  function cfgPreviewMaterial(mat, name) {
    return isBackedAlcantaraColor(name) ? 'Backed Alcantara' : mat;
  }

  const SHARED_THUMB_MATERIALS = new Set([
    'Faux Leather',
    'Genuine Leather',
    'Alcantara',
    'Suede',
    'Carbon Fiber',
  ]);

  /** Shared thumb folder (same swatch on Top & Bottom and Left & Right steps). */
  function cfgThumbParts(side, mat, name) {
    if (SHARED_THUMB_MATERIALS.has(mat)) return ['Thumb', mat, name];
    return ['Thumb', side, mat, name];
  }

  /** Marker thumb = exact PNG name in Thumb/12 O'clock marker/<name>.png */
  function cfgMarkerThumbParts(name) {
    return ['Thumb', "12 O'clock marker", name];
  }

  /** Marker preview overlay on steering wheel — always PNG (no .webp variants for all markers). */
  function cfgMarkerAssetUrl(assetBase, assetQuery, name) {
    return cfgThumbAssetUrl(assetBase, assetQuery, "12 O'clock marker", name);
  }

  /** Thumb-only markers (e.g. Special Grid) — menu right, no strip on steering preview left. */
  function markerHasSteeringPreview(manifest, name) {
    return !(manifest.MARKERS_THUMB_ONLY || []).includes(name);
  }

  function isGridMarker(manifest, name) {
    return (manifest.MARKERS_THUMB_ONLY || []).includes(name);
  }

  /** Grid markers only when Top & Bottom = Alcantara (not backed Red/White #9040). */
  function gridMarkersAllowed(manifest, tbMaterial, topBottom) {
    const reqMat = manifest.MARKER_GRID_TB_MATERIAL || 'Alcantara';
    const excluded = new Set(manifest.MARKER_GRID_TB_EXCLUDE_COLORS || [
      'Red Backed Alcantara #9040',
      'White Backed Alcantara #9040',
    ]);
    return tbMaterial === reqMat && !excluded.has(topBottom);
  }

  function markersForState(manifest, state) {
    const allowGrid = gridMarkersAllowed(manifest, state.tbMaterial, state.topBottom);
    return (manifest.MARKERS || []).filter((name) => allowGrid || !isGridMarker(manifest, name));
  }

  const DEFAULT_MATERIAL_INCOMPATIBLE = [
    ['Suede', 'Alcantara'],
    ['Faux Leather', 'Genuine Leather'],
  ];

  function materialsCompatible(manifest, matA, matB) {
    const pairs = manifest.MATERIAL_INCOMPATIBLE_PAIRS || DEFAULT_MATERIAL_INCOMPATIBLE;
    for (const [a, b] of pairs) {
      if ((matA === a && matB === b) || (matA === b && matB === a)) return false;
    }
    return true;
  }

  function lrMaterialsForState(manifest, state) {
    return (manifest.LR_MATERIALS || []).filter((m) =>
      materialsCompatible(manifest, state.tbMaterial, m)
    );
  }

  const MATERIAL_COMBO_BLOCKED = ' — combination not possible';

  /** Thread swatch in menu: Configurator/Thread/<name>.png */
  function cfgThreadThumbUrl(assetBase, assetQuery, name) {
    return cfgThumbAssetUrl(assetBase, assetQuery, 'Thread', name);
  }

  /** Wizard example (step 1 / 3) — prefer WebP; PNG fallback in UI on error. */
  function cfgExampleAssetUrl(assetBase, assetQuery, side) {
    const file =
      CFG_ASSET_PREFIX + ['Example', side].map(cfgSafeSegment).join('__') + '.webp';
    return joinAssetUrl(assetBase, file, assetQuery);
  }

  function cfgExamplePngUrl(assetBase, assetQuery, side) {
    return cfgThumbAssetUrl(assetBase, assetQuery, 'Example', side);
  }

  function probeWebp(assetBase, assetQuery) {
    return new Promise((resolve) => {
      const probe = new Image();
      const probeUrl = joinAssetUrl(assetBase, CFG_ASSET_PREFIX + 'Base.webp', assetQuery);
      let done = false;
      const finish = (ok) => {
        if (done) return;
        done = true;
        resolve(ok);
      };
      const timer = setTimeout(() => finish(false), 4000);
      probe.onload = () => {
        clearTimeout(timer);
        finish(probe.naturalWidth > 0);
      };
      probe.onerror = () => {
        clearTimeout(timer);
        finish(false);
      };
      probe.src = probeUrl;
    });
  }

  function collectImageUrls(manifest, assetBase, assetQuery) {
    const { TB_MATERIALS, TB, LR_MATERIALS, LR, MARKERS } = manifest;
    const urls = new Set();
    urls.add(cfgAssetUrl(assetBase, assetQuery, 'Base'));
    TB_MATERIALS.forEach((mat) => {
      TB[mat].forEach((name) => {
        urls.add(cfgAssetUrl(assetBase, assetQuery, 'Top&Bottom', cfgPreviewMaterial(mat, name), name));
        urls.add(cfgThumbAssetUrl(assetBase, assetQuery, ...cfgThumbParts('Top&Bottom', mat, name)));
      });
    });
    LR_MATERIALS.forEach((mat) => {
      LR[mat].forEach((name) => {
        urls.add(cfgAssetUrl(assetBase, assetQuery, 'Left&Right', cfgPreviewMaterial(mat, name), name));
        urls.add(cfgThumbAssetUrl(assetBase, assetQuery, ...cfgThumbParts('Left&Right', mat, name)));
      });
    });
    MARKERS.forEach((name) => {
      urls.add(cfgThumbAssetUrl(assetBase, assetQuery, ...cfgMarkerThumbParts(name)));
      if (markerHasSteeringPreview(manifest, name)) {
        urls.add(cfgMarkerAssetUrl(assetBase, assetQuery, name));
      }
    });
    (manifest.THREAD_OPTIONS || []).forEach((opt) => {
      urls.add(cfgThreadThumbUrl(assetBase, assetQuery, opt.name));
    });
    urls.add(cfgExampleAssetUrl(assetBase, assetQuery, 'Top&Bottom'));
    urls.add(cfgExamplePngUrl(assetBase, assetQuery, 'Top&Bottom'));
    urls.add(cfgExampleAssetUrl(assetBase, assetQuery, 'Left&Right'));
    urls.add(cfgExamplePngUrl(assetBase, assetQuery, 'Left&Right'));
    return Array.from(urls);
  }

  const PRELOADED_URLS = new Set();

  /** Start loading into the browser cache (memory / HTTP cache). Same URL = instant on next <img>. */
  function warmImageUrl(src) {
    if (!src || PRELOADED_URLS.has(src)) return;
    PRELOADED_URLS.add(src);
    const img = new Image();
    img.decoding = 'async';
    img.src = src;
  }

  function preloadImages(urls, onProgress, timeoutMs = 15000) {
    const fresh = urls.filter((u) => u && !PRELOADED_URLS.has(u));
    const total = fresh.length;
    if (!total) {
      if (typeof onProgress === 'function') onProgress(100);
      return Promise.resolve();
    }
    let loaded = 0;
    const tick = (resolve) => {
      loaded += 1;
      if (typeof onProgress === 'function') {
        onProgress(Math.min(100, Math.round((loaded / total) * 100)));
      }
      resolve();
    };
    const loadOne = (src) =>
      new Promise((resolve) => {
        let done = false;
        const finish = () => {
          if (done) return;
          done = true;
          tick(resolve);
        };
        const timer = setTimeout(finish, timeoutMs);
        const img = new Image();
        img.decoding = 'async';
        PRELOADED_URLS.add(src);
        img.onload = () => {
          clearTimeout(timer);
          finish();
        };
        img.onerror = () => {
          clearTimeout(timer);
          finish();
        };
        img.src = src;
      });
    return Promise.all(fresh.map(loadOne));
  }

  function preloadInChunks(urls, chunkSize = 6) {
    const queue = urls.filter((u) => u && !PRELOADED_URLS.has(u));
    if (!queue.length) return;
    const schedule =
      typeof window.requestIdleCallback === 'function'
        ? (cb) => window.requestIdleCallback(cb, { timeout: 1500 })
        : (cb) => setTimeout(cb, 60);
    const processChunk = () => {
      const slice = queue.splice(0, chunkSize);
      if (!slice.length) return;
      preloadImages(slice).finally(() => {
        if (queue.length) schedule(processChunk);
      });
    };
    schedule(processChunk);
  }

  function compressImageFile(file, maxDim = 1600, quality = 0.82) {
    return new Promise((resolve, reject) => {
      if (!file.type.startsWith('image/')) {
        resolve(file);
        return;
      }
      const img = new Image();
      const url = URL.createObjectURL(file);
      img.onload = () => {
        URL.revokeObjectURL(url);
        let { width, height } = img;
        const scale = Math.min(1, maxDim / Math.max(width, height));
        width = Math.round(width * scale);
        height = Math.round(height * scale);
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        canvas.getContext('2d').drawImage(img, 0, 0, width, height);
        canvas.toBlob(
          (blob) => {
            if (!blob) {
              resolve(file);
              return;
            }
            resolve(new File([blob], file.name.replace(/\.\w+$/, '.jpg') || 'wheel.jpg', { type: 'image/jpeg' }));
          },
          'image/jpeg',
          quality
        );
      };
      img.onerror = () => {
        URL.revokeObjectURL(url);
        resolve(file);
      };
      img.src = url;
    });
  }

  const DEFAULT_MATERIAL_SURCHARGES_GBP = {
    'Faux Leather': 0,
    'Genuine Leather': 10,
    Suede: 10,
    'Carbon Fiber': 10,
    Alcantara: 27.5,
  };

  function materialSurcharges(manifest) {
    return manifest?.MATERIAL_SURCHARGES_GBP || DEFAULT_MATERIAL_SURCHARGES_GBP;
  }

  const SURCHARGE_SOURCE_CURRENCY = 'GBP';

  function materialSurchargeGbp(manifest, material) {
    return materialSurcharges(manifest)[material] ?? 0;
  }

  function currencyRate(config) {
    const rate = Number(config.currencyRate);
    if (rate > 0 && !Number.isNaN(rate)) return rate;
    return 1;
  }

  function materialSurchargeCents(manifest, material, config) {
    const gbpPounds = materialSurchargeGbp(manifest, material);
    return Math.round(gbpPounds * 100 * currencyRate(config));
  }

  const DEFAULT_VARIANT_BY_SURCHARGE_GBP = {
    0: 'Standard',
    10: '1',
    20: '2',
    27.5: '3',
    37.5: '4',
    55: '5',
  };

  function totalSurchargeGbp(manifest, state) {
    return (
      materialSurchargeGbp(manifest, state.tbMaterial) +
      materialSurchargeGbp(manifest, state.lrMaterial)
    );
  }

  function normalizeVariantTitle(title) {
    return String(title || '').trim();
  }

  function variantCatalog(config) {
    return config.variants || [];
  }

  function shopPriceCentsForVariant(variant, config) {
    if (variant?.priceShop != null) return variant.priceShop;
    const fromConfig = variantCatalog(config).find((v) => String(v.id) === String(variant?.id));
    if (fromConfig?.priceShop != null) return fromConfig.priceShop;
    return variant?.price ?? null;
  }

  function findStandardVariant(variants, config) {
    const title = config.baseVariantTitle || 'Standard';
    const byTitle = variants.find((v) => normalizeVariantTitle(v.title) === normalizeVariantTitle(title));
    if (byTitle) return byTitle;
    return [...variants].sort((a, b) => (a.price ?? 0) - (b.price ?? 0))[0] || null;
  }

  function pickVariantForState(cartProduct, state, manifest, config) {
    const variants = cartProduct?.variants || variantCatalog(config);
    if (!variants?.length) return null;

    const totalGbp = totalSurchargeGbp(manifest, state);
    const map = config.variantBySurchargeGbp || DEFAULT_VARIANT_BY_SURCHARGE_GBP;
    const wantedTitle = map[String(totalGbp)] ?? map[totalGbp];

    if (wantedTitle) {
      const byTitle = variants.find(
        (v) => normalizeVariantTitle(v.title) === normalizeVariantTitle(wantedTitle)
      );
      if (byTitle) return byTitle;
    }

    const standard = findStandardVariant(variants, config);
    const baseShop = shopPriceCentsForVariant(standard, config) ?? config.basePriceShopCents ?? 6295;
    const expectedShopCents = Math.round(baseShop + totalGbp * 100);

    const byShopPrice = variants.find((v) => shopPriceCentsForVariant(v, config) === expectedShopCents);
    if (byShopPrice) return byShopPrice;

    return variants.find((v) => v.available !== false) || variants[0];
  }

  function calculateTotalCents(config, manifest, state, cartProduct) {
    const variant = pickVariantForState(cartProduct, state, manifest, config);
    if (variant?.price != null) return variant.price;

    const base = config.basePriceCents ?? 6295;
    return (
      base +
      materialSurchargeCents(manifest, state.tbMaterial, config) +
      materialSurchargeCents(manifest, state.lrMaterial, config)
    );
  }

  function formatConfigMoney(cents, config) {
    const currency = config.currency || config.shopCurrency || SURCHARGE_SOURCE_CURRENCY;
    if (typeof Intl !== 'undefined' && typeof Intl.NumberFormat === 'function') {
      try {
        return new Intl.NumberFormat(config.moneyLocale || undefined, {
          style: 'currency',
          currency,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(cents / 100);
      } catch (e) {
        /* fall through */
      }
    }
    if (typeof window !== 'undefined' && window.Shopify?.formatMoney && config.moneyFormat) {
      return window.Shopify.formatMoney(cents, config.moneyFormat);
    }
    const amount = (cents / 100).toFixed(2);
    if (currency === 'USD') return `$${amount}`;
    if (currency === 'EUR') return `€${amount}`;
    return `£${amount}`;
  }

  function materialOptionLabel(manifest, material, config) {
    const gbp = materialSurchargeGbp(manifest, material);
    if (gbp <= 0) return material;
    return `${material} (+${formatConfigMoney(materialSurchargeCents(manifest, material, config), config)})`;
  }

  function readThemeCurrencyRate() {
    const rate = parseFloat(window.Shopify?.currency?.rate);
    return rate > 0 && !Number.isNaN(rate) ? rate : null;
  }

  async function resolveCurrencyContext(config, cartProduct) {
    config.shopCurrency = config.shopCurrency || SURCHARGE_SOURCE_CURRENCY;
    config.currency =
      window.Shopify?.currency?.active || config.currency || config.shopCurrency;

    const variants = cartProduct?.variants || variantCatalog(config);
    const standard = findStandardVariant(variants, config);
    if (standard) {
      const shop = shopPriceCentsForVariant(standard, config);
      if (shop != null) config.basePriceShopCents = shop;
    }
    if (!config.basePriceShopCents) {
      config.basePriceShopCents = config.basePriceCents ?? 6295;
    }

    if (standard?.price != null && cartProduct?.variants) {
      config.basePriceCents = standard.price;
      config.currencyRate =
        config.basePriceShopCents > 0 ? standard.price / config.basePriceShopCents : 1;
      return;
    }

    const themeRate = readThemeCurrencyRate();
    if (themeRate != null) {
      config.currencyRate = themeRate;
      config.basePriceCents = Math.round(config.basePriceShopCents * themeRate);
      return;
    }

    if (config.currency !== config.shopCurrency && config.productHandle) {
      try {
        const product = await fetchProductJson(config.productHandle);
        const variant = findStandardVariant(product?.variants || [], config);
        if (variant?.price != null) {
          config.basePriceCents = variant.price;
          config.currencyRate =
            config.basePriceShopCents > 0 ? variant.price / config.basePriceShopCents : 1;
          return;
        }
      } catch (e) {
        console.warn('[CMW configurator] Could not load presentment base price', e);
      }
    }

    config.currencyRate = 1;
    config.basePriceCents = config.basePriceShopCents;
  }

  function shopifyRoot() {
    const raw = (typeof window !== 'undefined' && window.Shopify?.routes?.root) || '/';
    return raw.endsWith('/') ? raw : `${raw}/`;
  }

  async function fetchProductJson(handle) {
    const res = await fetch(
      `${shopifyRoot()}products/${encodeURIComponent(handle)}.js?t=${Date.now()}`,
      { credentials: 'same-origin', cache: 'no-store' }
    );
    if (!res.ok) return null;
    return res.json();
  }

  function findNativeCartForm(sectionId) {
    const section = document.getElementById(`shopify-section-${sectionId}`);
    return section?.querySelector('form[data-cmw-native-cart-form]') || null;
  }

  function lineItemProperties(state, config, manifest, cartProduct) {
    const tbSurchargeCents = materialSurchargeCents(manifest, state.tbMaterial, config);
    const lrSurchargeCents = materialSurchargeCents(manifest, state.lrMaterial, config);
    const selectedVariant = pickVariantForState(cartProduct, state, manifest, config);
    const totalCents = selectedVariant?.price ?? calculateTotalCents(config, manifest, state, cartProduct);

    // Customer-visible properties (order matters in cart). Internal data uses _ prefix (hidden).
    const props = {
      'Your Car': state.vehicle.trim(),
      'Top and Bottom': state.topBottom,
      'Left and Right': state.leftRight,
      Thread: state.thread.name,
      '12 o clock marker': state.markerEnabled === 'Yes' ? state.marker : 'No',
      'Paddle shifters': state.paddleShifters,
      'Calculated total': formatConfigMoney(totalCents, config),
      _cmw_currency: config.currency || config.shopCurrency || SURCHARGE_SOURCE_CURRENCY,
      _cmw_tb_material: state.tbMaterial,
      _cmw_lr_material: state.lrMaterial,
      _cmw_tb_surcharge_cents: String(tbSurchargeCents),
      _cmw_lr_surcharge_cents: String(lrSurchargeCents),
      _cmw_total_cents: String(totalCents),
      _cmw_variant: selectedVariant?.title || '',
    };
    return props;
  }

  function variantDebugLine(v) {
    return `ID ${v.id}: available=${v.available}, qty=${v.inventory_quantity ?? '?'}, policy=${v.inventory_policy || '?'}`;
  }

  function scoreVariant(v) {
    let score = 0;
    if (v.available) score += 100;
    if (v.inventory_policy === 'continue') score += 50;
    if (!v.inventory_management || v.inventory_management !== 'shopify') score += 80;
    if ((v.inventory_quantity ?? 0) > 0) score += 10;
    return score;
  }

  function orderVariantsForCart(variants) {
    if (!variants?.length) return [];
    return [...variants].sort((a, b) => scoreVariant(b) - scoreVariant(a));
  }

  async function loadCartProduct(config) {
    const enrichVariants = (variants) => {
      const catalog = variantCatalog(config);
      return (variants || []).map((v) => {
        const cfg = catalog.find((c) => String(c.id) === String(v.id));
        if (cfg?.priceShop != null && v.priceShop == null) {
          return { ...v, priceShop: cfg.priceShop };
        }
        return v;
      });
    };

    if (config.productHandle) {
      const product = await fetchProductJson(config.productHandle);
      if (product?.variants?.length) {
        product.variants = enrichVariants(product.variants);
        return product;
      }
    }
    if (config.variants?.length) {
      return {
        id: config.productId,
        title: config.productTitle,
        variants: enrichVariants(config.variants),
      };
    }
    return null;
  }

  function isDesignMode(config) {
    return Boolean(
      config.designMode ||
        (typeof window !== 'undefined' &&
          (window.Shopify?.designMode ||
            document.documentElement.classList.contains('shopify-design-mode')))
    );
  }

  async function buildCartFormFields(config, state, variantId, form, manifest, cartProduct) {
    const native = findNativeCartForm(config.sectionId);
    const addField = (name, value) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    };

    if (native) {
      native.querySelectorAll('input[name="utf8"], input[name="form_type"]').forEach((inp) => {
        addField(inp.name, inp.value);
      });
    } else {
      addField('form_type', 'product');
      addField('utf8', '✓');
    }

    addField('id', String(variantId));
    addField('quantity', '1');

    Object.entries(lineItemProperties(state, config, manifest, cartProduct)).forEach(([key, val]) => {
      addField(`properties[${key}]`, val);
    });

    if (state.photo?.file) {
      const photoFile = await compressImageFile(state.photo.file);
      const fileInput = document.createElement('input');
      fileInput.type = 'file';
      fileInput.name = 'properties[Steering wheel photo]';
      const dt = new DataTransfer();
      dt.items.add(photoFile);
      fileInput.files = dt.files;
      form.appendChild(fileInput);
    }
  }

  /** Same mechanism as /cart/VARIANT:1 in the browser; bypasses broken Ajax add.js on some themes. */
  async function submitCartViaFormPost(config, state, variantId, manifest, cartProduct, options = {}) {
    const destination = options.destination === 'checkout' ? 'checkout' : 'cart';

    if (isDesignMode(config)) {
      throw new Error(
        'Add to cart is not available in the theme editor. Use View on your store to test checkout.'
      );
    }

    if (config.devMode) {
      const form = document.createElement('form');
      await buildCartFormFields(config, state, variantId, form, manifest, cartProduct);
      const body = new FormData(form);
      const res = await fetch(`${shopifyRoot()}cart/add`, {
        method: 'POST',
        body,
        credentials: 'same-origin',
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        throw new Error(data.description || data.message || 'Could not add to cart.');
      }
      console.info(
        `[CMW configurator] Dev add-to-cart OK → would go to ${destination === 'checkout' ? '/checkout' : '/cart'}`,
        data
      );
      return { ...data, destination };
    }

    const native = findNativeCartForm(config.sectionId);
    const action = native?.getAttribute('action') || `${shopifyRoot()}cart/add`;

    const form = document.createElement('form');
    form.method = 'POST';
    form.action = action;
    form.enctype = 'multipart/form-data';
    form.acceptCharset = 'UTF-8';
    form.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;opacity:0;';

    const addField = (name, value) => {
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      input.value = value;
      form.appendChild(input);
    };

    await buildCartFormFields(config, state, variantId, form, manifest, cartProduct);

    let returnTo =
      destination === 'checkout'
        ? config.checkoutUrl || `${shopifyRoot()}checkout`
        : config.cartPageUrl || `${shopifyRoot()}cart`;
    if (returnTo.startsWith('http')) {
      try {
        const u = new URL(returnTo);
        returnTo = u.pathname + u.search;
      } catch {
        returnTo = destination === 'checkout' ? '/checkout' : '/cart';
      }
    }
    addField('return_to', returnTo || (destination === 'checkout' ? '/checkout' : '/cart'));

    document.body.appendChild(form);
    form.submit();
  }

  async function addToCart(config, state, manifest, cartProduct, options = {}) {
    const product = cartProduct || (await loadCartProduct(config));
    const variant = pickVariantForState(product, state, manifest, config);

    if (!variant?.id) {
      throw new Error('No cart product is configured for this section.');
    }
    if (variant.available === false) {
      throw new Error('This material combination is currently unavailable.');
    }

    config.variantId = variant.id;
    await submitCartViaFormPost(config, state, variant.id, manifest, product, options);
  }

  function buildConfigurator(root, config, manifest, cartProduct) {
    const assetBase = config.assetBase;
    const assetQuery = config.assetQuery != null ? String(config.assetQuery) : '';
    const url = {
      base: () => cfgAssetUrl(assetBase, assetQuery, 'Base'),
      tb: (mat, name) => cfgAssetUrl(assetBase, assetQuery, 'Top&Bottom', cfgPreviewMaterial(mat, name), name),
      lr: (mat, name) => cfgAssetUrl(assetBase, assetQuery, 'Left&Right', cfgPreviewMaterial(mat, name), name),
      marker: (name) => cfgMarkerAssetUrl(assetBase, assetQuery, name),
      tbThumb: (mat, name) => cfgThumbAssetUrl(assetBase, assetQuery, ...cfgThumbParts('Top&Bottom', mat, name)),
      lrThumb: (mat, name) => cfgThumbAssetUrl(assetBase, assetQuery, ...cfgThumbParts('Left&Right', mat, name)),
      markerThumb: (name) => cfgThumbAssetUrl(assetBase, assetQuery, ...cfgMarkerThumbParts(name)),
      threadThumb: (name) => cfgThreadThumbUrl(assetBase, assetQuery, name),
      example: (side) => cfgExampleAssetUrl(assetBase, assetQuery, side),
      examplePng: (side) => cfgExamplePngUrl(assetBase, assetQuery, side),
    };

    const state = {
      tbMaterial: manifest.TB_MATERIALS[0],
      topBottom: manifest.TB[manifest.TB_MATERIALS[0]][0],
      lrMaterial: manifest.LR_MATERIALS[0],
      leftRight: manifest.LR[manifest.LR_MATERIALS[0]][0],
      markerEnabled: 'No',
      marker: manifest.MARKERS[0],
      thread: manifest.THREAD_OPTIONS[0],
      photo: null,
      vehicle: '',
      paddleShifters: 'No',
      wizardStep: 0,
    };

    const shell = el('div', 'cfg-shell');
    root.appendChild(shell);

    const main = el('div');
    main.className = 'cfg-main cfg-is-loading';
    main.setAttribute('aria-busy', 'true');
    const loadStatus = el('p', 'visually-hidden cfg-load-status', {
      text: 'Loading…',
      'aria-live': 'polite',
    });

    const preview = {
      tb: el('img', 'cfg-layer cfg-pz-1', { alt: '', decoding: 'async' }),
      lr: el('img', 'cfg-layer cfg-pz-2', { alt: '', decoding: 'async' }),
      marker: el('img', 'cfg-layer cfg-pz-4', { alt: '', decoding: 'async' }),
      chips: el('div', 'cfg-preview__chips'),
    };

    const refs = {
      tbGrid: el('div', 'cfg-grid-sw'),
      lrGrid: el('div', 'cfg-grid-sw'),
      markerGrid: el('div', 'cfg-grid-sw'),
      markerWrap: el('div'),
      threadGrid: el('div', 'cfg-grid-sw'),
      tbSelect: el('select'),
      lrSelect: el('select'),
      cartBtn: null,
      errorBox: null,
      uploadInput: el('input', null, { type: 'file', accept: '.png,.jpg,.jpeg,.heic,.pdf,.ai,.eps', style: 'display:none' }),
      uploadZone: null,
    };

    function setLayerSrc(img, src) {
      if (!img) return;
      if (img.dataset.cfgSrc === src) return;
      warmImageUrl(src);
      img.dataset.cfgSrc = src;
      img.classList.add('is-loading');
      const done = () => img.classList.remove('is-loading');
      img.onload = done;
      img.onerror = () => {
        if (!img.dataset.cfgWarned) {
          img.dataset.cfgWarned = '1';
          console.warn('[CMW configurator] Image not found:', src);
        }
        done();
      };
      img.src = src;
      if (img.complete && img.naturalWidth > 0) done();
      else if (typeof img.decode === 'function') {
        img.decode().then(done).catch(() => {});
      }
    }

    function syncWizardChrome() {
      if (!refs.wizardTitle) return;
      const step = WIZARD_STEPS[state.wizardStep];
      refs.wizardTitle.textContent = step.title;
      const sel = step.selection ? step.selection(state) : '';
      refs.wizardSelection.textContent = sel;
      refs.wizardSelection.hidden = !sel;
      refs.wizardHint.textContent = step.hint || '';
      refs.wizardHint.hidden = !step.hint;
      if (refs.wizardInfoBtn) {
        const hasExample = Boolean(exampleSideForStep(step.id));
        refs.wizardInfoBtn.hidden = !hasExample;
        refs.wizardInfoBtn.setAttribute(
          'aria-label',
          hasExample ? 'View example image' : 'More information'
        );
        refs.wizardInfoBtn.setAttribute('aria-expanded', 'false');
      }
      if (refs.wizardInfoPopover) {
        refs.wizardInfoPopover.hidden = true;
        refs.wizardInfoPopover.innerHTML = '';
        refs.wizardInfoPopover.removeAttribute('style');
      }
      if (refs.previewDots) {
        refs.previewDots.querySelectorAll('[data-dot]').forEach((dot, i) => {
          dot.classList.toggle('is-active', i === state.wizardStep);
          dot.setAttribute('aria-current', i === state.wizardStep ? 'step' : 'false');
        });
      }
      if (refs.progressItems) {
        refs.progressItems.forEach((item, i) => {
          item.classList.toggle('is-active', i === state.wizardStep);
          item.classList.toggle('is-done', i < state.wizardStep);
          item.setAttribute('aria-current', i === state.wizardStep ? 'step' : 'false');
        });
      }
    }
    const syncMobileWizardChrome = syncWizardChrome;

    function exampleSideForStep(stepId) {
      if (stepId === 'tb-mat') return 'Top&Bottom';
      if (stepId === 'lr-mat') return 'Left&Right';
      return null;
    }

    function setExampleImg(img, side) {
      const webpSrc = url.example(side);
      const pngSrc = url.examplePng(side);
      if (img.dataset.cfgSrc === webpSrc) return;
      img.dataset.cfgSrc = webpSrc;
      img.onerror = function onExampleErr() {
        if (img.src !== pngSrc) {
          img.src = pngSrc;
          img.dataset.cfgSrc = pngSrc;
        }
      };
      img.src = webpSrc;
    }

    function refreshExampleImages() {
      if (!refs.examples) return;
      Object.entries(refs.examples).forEach(([stepId, img]) => {
        const side = exampleSideForStep(stepId);
        if (side) setExampleImg(img, side);
      });
    }

    function updatePreview() {
      setLayerSrc(preview.tb, url.tb(state.tbMaterial, state.topBottom));
      setLayerSrc(preview.lr, url.lr(state.lrMaterial, state.leftRight));
      if (
        state.markerEnabled === 'Yes' &&
        markerHasSteeringPreview(manifest, state.marker)
      ) {
        setLayerSrc(preview.marker, url.marker(state.marker));
        preview.marker.hidden = false;
      } else {
        preview.marker.hidden = true;
      }
      preview.chips.innerHTML = '';
      preview.chips.append(
        el('span', 'cfg-preview__note', { text: 'Visual example, not actual final product' })
      );
      if (refs.previewLive) {
        refs.previewLive.innerHTML = '';
        refs.previewLive.hidden = false;
        refs.previewLive.append(
          el('span', 'cfg-preview__note', { text: 'Visual example, not actual final product' })
        );
      }
      refreshExampleImages();
      syncWizardChrome();
      if (refs.previewLightbox && !refs.previewLightbox.hidden) syncPreviewLightboxLayers();
    }

    function syncSwatchSelection(container, selected) {
      container.querySelectorAll('.cfg-sw').forEach((btn) => {
        const name = btn.getAttribute('title') || '';
        const isSelected = name === selected;
        btn.classList.toggle('is-selected', isSelected);
        btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        const tile = btn.querySelector('.cfg-sw__tile');
        if (!tile) return;
        const check = tile.querySelector('.cfg-sw__check');
        if (isSelected && !check) {
          tile.appendChild(el('span', 'cfg-sw__check', { html: SVG.check }));
        } else if (!isSelected && check) {
          check.remove();
        }
      });
    }

    function bindSwatchWarm(btn, name, srcFn, previewSrcFn) {
      const warm = () => {
        warmImageUrl(srcFn(name));
        if (previewSrcFn) warmImageUrl(previewSrcFn(name));
      };
      btn.addEventListener('mouseenter', warm, { passive: true });
      btn.addEventListener('focus', warm, { passive: true });
    }

    function renderImgSwatches(container, items, selected, onSelect, srcFn, fallbackSrcFn, previewSrcFn) {
      const list = items || [];
      const itemsKey = list.join('\0');
      const eager = container.closest('.cfg-marker-options') != null;
      if (
        container.dataset.cfgItemsKey === itemsKey &&
        container.childElementCount === list.length
      ) {
        syncSwatchSelection(container, selected);
        return;
      }
      container.dataset.cfgItemsKey = itemsKey;
      container.innerHTML = '';
      list.forEach((name) => {
        const btn = el('button', `cfg-sw${name === selected ? ' is-selected' : ''}`, {
          type: 'button',
          title: name,
          'aria-pressed': name === selected ? 'true' : 'false',
        });
        const tile = el('span', 'cfg-sw__tile');
        const thumbSrc = srcFn(name);
        const img = el('img', null, {
          alt: '',
          loading: eager ? 'eager' : 'lazy',
          decoding: 'async',
          fetchpriority: eager ? 'high' : 'low',
          width: '200',
          height: '200',
          src: thumbSrc,
        });
        const fallbacks = [];
        if (fallbackSrcFn) {
          const fb = fallbackSrcFn(name);
          if (fb && fb !== thumbSrc) fallbacks.push(fb);
        }
        if (fallbacks.length) {
          let fi = 0;
          img.addEventListener('error', function onThumbError() {
            while (fi < fallbacks.length) {
              const next = fallbacks[fi++];
              if (img.src !== next) {
                img.src = next;
                return;
              }
            }
          });
        }
        tile.appendChild(img);
        appendPopularBadge(tile, name);
        if (name === selected) {
          const check = el('span', 'cfg-sw__check', { html: SVG.check });
          tile.appendChild(check);
        }
        btn.append(tile, el('span', 'cfg-sw__label', { text: name }));
        if (previewSrcFn) bindSwatchWarm(btn, name, srcFn, previewSrcFn);
        btn.addEventListener('click', () => onSelect(name));
        container.appendChild(btn);
      });
    }

    function urlsForWizardStep(stepId) {
      const out = [];
      switch (stepId) {
        case 'tb-sw':
          (manifest.TB[state.tbMaterial] || []).forEach((n) => {
            out.push(url.tbThumb(state.tbMaterial, n), url.tb(state.tbMaterial, n));
          });
          break;
        case 'lr-sw':
          (manifest.LR[state.lrMaterial] || []).forEach((n) => {
            out.push(url.lrThumb(state.lrMaterial, n), url.lr(state.lrMaterial, n));
          });
          break;
        case 'marker':
          manifest.MARKERS.forEach((n) => {
            out.push(url.markerThumb(n));
            if (markerHasSteeringPreview(manifest, n)) out.push(url.marker(n));
          });
          break;
        case 'thread':
          (manifest.THREAD_OPTIONS || []).forEach((opt) => {
            out.push(url.threadThumb(opt.name));
          });
          break;
        default:
          break;
      }
      return out;
    }

    function renderThreadSwatches() {
      refs.threadGrid.innerHTML = '';
      manifest.THREAD_OPTIONS.forEach((opt) => {
        const selected = opt.name === state.thread.name;
        const btn = el('button', `cfg-sw cfg-sw--thread${selected ? ' is-selected' : ''}`, {
          type: 'button',
          title: opt.name,
          'aria-pressed': selected ? 'true' : 'false',
        });
        const tile = el('span', 'cfg-sw__tile');
        const thumbSrc = url.threadThumb(opt.name);
        const img = el('img', null, {
          alt: '',
          loading: 'lazy',
          decoding: 'async',
          src: thumbSrc,
        });
        if (opt.swatchBg || opt.stroke) {
          img.addEventListener('error', function onThreadThumbError() {
            img.removeEventListener('error', onThreadThumbError);
            const fill = el('span', 'cfg-thread-fill');
            fill.style.background = opt.swatchBg || opt.stroke;
            fill.style.border = `1px solid ${opt.swatchBorder || '#e5e7eb'}`;
            tile.replaceChildren(fill);
            appendPopularBadge(tile, opt.name);
          });
        }
        tile.appendChild(img);
        appendPopularBadge(tile, opt.name);
        if (selected) tile.appendChild(el('span', 'cfg-sw__check', { html: SVG.check }));
        btn.append(tile, el('span', 'cfg-sw__label', { text: opt.name }));
        const warmThread = () => warmImageUrl(thumbSrc);
        btn.addEventListener('mouseenter', warmThread, { passive: true });
        btn.addEventListener('focus', warmThread, { passive: true });
        btn.addEventListener('click', () => {
          warmImageUrl(thumbSrc);
          state.thread = opt;
          renderThreadSwatches();
          updateBadges();
        });
        refs.threadGrid.appendChild(btn);
      });
    }

    let materialSyncLock = false;

    function fillMaterialSelect(select, materials, value, onChange, { disabledMaterials = [] } = {}) {
      const disabledSet = new Set(disabledMaterials);
      const list = materials || [];
      select.innerHTML = '';
      list.forEach((m) => {
        const blocked = disabledSet.has(m);
        const label =
          materialOptionLabel(manifest, m, config) + (blocked ? MATERIAL_COMBO_BLOCKED : '');
        const opt = el('option', null, { value: m, text: label });
        if (blocked) opt.disabled = true;
        select.appendChild(opt);
      });
      const enabled = list.filter((m) => !disabledSet.has(m));
      if (enabled.includes(value)) select.value = value;
      else if (enabled.length) select.value = enabled[0];
      else if (list.length) select.value = list[0];
      select.onchange = () => {
        if (materialSyncLock) return;
        if (disabledSet.has(select.value)) return;
        onChange(select.value);
      };
    }

    /** Left & Right: show all materials; incompatible ones disabled with label suffix. */
    function fillLrMaterialSelect() {
      const all = manifest.LR_MATERIALS || [];
      const disabled = all.filter((m) => !materialsCompatible(manifest, state.tbMaterial, m));
      const enabled = all.filter((m) => materialsCompatible(manifest, state.tbMaterial, m));
      if (!enabled.includes(state.lrMaterial) && enabled.length) {
        state.lrMaterial = enabled[0];
        state.leftRight = manifest.LR[state.lrMaterial]?.[0] || '';
      }
      fillMaterialSelect(refs.lrSelect, all, state.lrMaterial, onLrMaterialChange, {
        disabledMaterials: disabled,
      });
      return enabled;
    }

    function updatePriceDisplay() {
      const total = formatConfigMoney(calculateTotalCents(config, manifest, state, cartProduct), config);
      if (refs.priceEl) refs.priceEl.textContent = total;
      if (refs.heroPrice) refs.heroPrice.textContent = total;
      if (refs.summaryTotal) refs.summaryTotal.textContent = total;
    }

    function refreshTbGrid() {
      renderImgSwatches(
        refs.tbGrid,
        manifest.TB[state.tbMaterial] || [],
        state.topBottom,
        (name) => {
          if (state.topBottom === name) return;
          warmImageUrl(url.tb(state.tbMaterial, name));
          state.topBottom = name;
          syncSwatchSelection(refs.tbGrid, name);
          ensureValidMarkerSelection();
          if (state.markerEnabled === 'Yes') refreshMarkerGrid();
          updatePreview();
          updateBadges();
        },
        (name) => url.tbThumb(state.tbMaterial, name),
        null,
        (name) => url.tb(state.tbMaterial, name)
      );
    }

    function refreshLrGrid() {
      renderImgSwatches(
        refs.lrGrid,
        manifest.LR[state.lrMaterial] || [],
        state.leftRight,
        (name) => {
          if (state.leftRight === name) return;
          warmImageUrl(url.lr(state.lrMaterial, name));
          state.leftRight = name;
          syncSwatchSelection(refs.lrGrid, name);
          updatePreview();
          updateBadges();
        },
        (name) => url.lrThumb(state.lrMaterial, name),
        null,
        (name) => url.lr(state.lrMaterial, name)
      );
    }

    function ensureValidMarkerSelection() {
      const available = markersForState(manifest, state);
      if (!available.length) return;
      if (!available.includes(state.marker)) {
        state.marker = available[0];
        updatePreview();
      }
    }

    function refreshMarkerGrid() {
      ensureValidMarkerSelection();
      renderImgSwatches(
        refs.markerGrid,
        markersForState(manifest, state),
        state.marker,
        (name) => {
          if (state.marker === name) return;
          if (markerHasSteeringPreview(manifest, name)) warmImageUrl(url.marker(name));
          state.marker = name;
          syncSwatchSelection(refs.markerGrid, name);
          updatePreview();
          updateBadges();
        },
        (n) => url.markerThumb(n),
        null,
        (n) => (markerHasSteeringPreview(manifest, n) ? url.marker(n) : null)
      );
    }

    const badges = {};
    function section(title, subtitle, badgeKey, required, children) {
      const sec = el('section', 'cfg-sec');
      const head = el('header', 'cfg-sec__head');
      const titleWrap = el('div', null, { style: 'min-width:0' });
      const h3 = el('h3', 'cfg-sec__title', { text: title });
      if (required) h3.appendChild(el('span', 'cfg-sec__req', { text: 'Required' }));
      titleWrap.appendChild(h3);
      if (subtitle) titleWrap.appendChild(el('p', 'cfg-sec__sub', { text: subtitle }));
      head.appendChild(titleWrap);
      const badge = el('span', 'cfg-sec__badge');
      badges[badgeKey] = badge;
      head.appendChild(badge);
      const body = el('div');
      const list = Array.isArray(children) ? children : [children];
      list.forEach((c) => {
        if (c) body.appendChild(c);
      });
      sec.append(head, body);
      return sec;
    }

    function updateBadges() {
      badges.tbMat.textContent = state.tbMaterial;
      badges.tbVar.textContent = state.topBottom;
      badges.lrMat.textContent = state.lrMaterial;
      badges.lrVar.textContent = state.leftRight;
      badges.marker.textContent = state.markerEnabled === 'Yes' ? state.marker : 'No';
      badges.thread.textContent = state.thread.name;
      badges.photo.textContent = state.photo ? 'Uploaded' : '';
      if (badges.vehicle) {
        badges.vehicle.textContent = state.vehicle.trim() || '-';
      }
      if (badges.paddles) {
        badges.paddles.textContent = state.paddleShifters;
      }
      updateSummary();
    }

    function appendSummaryConfigRow(container, r) {
      const row = el('div', 'cfg-summary__row');
      const thumb = el('div', 'cfg-summary__thumb');
      if (r.img) {
        thumb.appendChild(el('img', null, { src: r.img, alt: '', loading: 'lazy' }));
      } else if (r.swatch) {
        thumb.style.background = r.swatch;
        thumb.classList.add('cfg-summary__thumb--swatch');
      } else {
        thumb.classList.add('cfg-summary__thumb--empty');
        thumb.textContent = '-';
      }
      const text = el('div', 'cfg-summary__text');
      text.append(
        el('p', 'cfg-summary__label', { text: r.label }),
        el('p', 'cfg-summary__value', { text: r.value })
      );
      row.append(thumb, text);
      container.appendChild(row);
    }

    function updateSummary() {
      if (!refs.summaryRows) return;
      const mobile = isMobileLayout();
      const rows = [
        {
          label: mobile ? 'Top' : 'Top & Bottom',
          value: mobile ? state.topBottom : `${state.topBottom}, ${state.tbMaterial}`,
          img: url.tb(state.tbMaterial, state.topBottom),
        },
        {
          label: mobile ? 'Sides' : 'Left & Right',
          value: mobile ? state.leftRight : `${state.leftRight}, ${state.lrMaterial}`,
          img: url.lr(state.lrMaterial, state.leftRight),
        },
        {
          label: mobile ? 'Marker' : "12 O'Clock marker",
          value:
            state.markerEnabled === 'Yes'
              ? mobile && state.marker.length > 14
                ? `${state.marker.slice(0, 12)}…`
                : state.marker
              : 'None',
          img:
            state.markerEnabled === 'Yes'
              ? markerHasSteeringPreview(manifest, state.marker)
                ? url.marker(state.marker)
                : url.markerThumb(state.marker)
              : null,
        },
        {
          label: 'Thread',
          value: state.thread.name,
          img: url.threadThumb(state.thread.name),
          swatch: null,
        },
      ];
      refs.summaryRows.innerHTML = '';
      rows.forEach((r) => appendSummaryConfigRow(refs.summaryRows, r));

      const isSummaryFieldMissing = (value) => {
        const v = typeof value === 'string' ? value.trim() : '';
        return !v || v === '-';
      };

      if (refs.summaryCarBlock) {
        const vehicleText = state.vehicle.trim();
        const vehicleMissing = isSummaryFieldMissing(vehicleText);
        refs.summaryCarBlock.className = `cfg-summary__car-block${vehicleMissing ? ' is-incomplete' : ''}`;
        refs.summaryCarBlock.innerHTML = '';
        refs.summaryCarBlock.append(
          el('p', 'cfg-summary__detail-label', { text: mobile ? 'Car' : 'Your Car' }),
          el('p', `cfg-summary__detail-value cfg-summary__detail-value--vehicle${vehicleMissing ? ' is-incomplete' : ''}`, {
            text: vehicleMissing ? '-' : vehicleText,
          }),
          el('p', 'cfg-summary__detail-label', { text: 'Paddle shifters' }),
          el('p', 'cfg-summary__detail-value', {
            text: state.paddleShifters === 'Yes' ? 'Yes' : 'No',
          })
        );
      }

      if (refs.summaryPhotoBlock) {
        const photoMissing = !state.photo?.previewUrl;
        refs.summaryPhotoBlock.className = `cfg-summary__photo-block${photoMissing ? ' is-incomplete' : ''}`;
        refs.summaryPhotoBlock.innerHTML = '';
        refs.summaryPhotoBlock.append(
          el('p', 'cfg-summary__detail-label', {
            text: mobile ? 'Wheel photo' : 'Photo of your steering wheel',
          })
        );
        if (!photoMissing) {
          const filled = el('div', 'cfg-summary__photo-filled');
          const meta = el('div', 'cfg-summary__photo-meta');
          meta.append(
            el('p', 'cfg-summary__photo-name', { text: state.photo.name }),
            el('p', 'cfg-summary__photo-size', {
              text: `${Math.round(state.photo.size / 1024)} KB`,
            })
          );
          filled.append(
            el('img', null, { alt: '', src: state.photo.previewUrl }),
            meta
          );
          refs.summaryPhotoBlock.appendChild(filled);
        } else {
          refs.summaryPhotoBlock.appendChild(
            el('div', 'cfg-summary__photo-empty is-incomplete', { text: '-' })
          );
        }
      }

      if (refs.summaryPriceRows) {
        const tbSurchargeCents = materialSurchargeCents(manifest, state.tbMaterial, config);
        const lrSurchargeCents = materialSurchargeCents(manifest, state.lrMaterial, config);
        refs.summaryPriceRows.innerHTML = '';
        const priceLines = [];
        if (tbSurchargeCents > 0) {
          priceLines.push({
            label: `Top & Bottom (${state.tbMaterial})`,
            value: `+${formatConfigMoney(tbSurchargeCents, config)}`,
          });
        }
        if (lrSurchargeCents > 0) {
          priceLines.push({
            label: `Left & Right (${state.lrMaterial})`,
            value: `+${formatConfigMoney(lrSurchargeCents, config)}`,
          });
        }
        priceLines.forEach((line) => {
          const row = el('div', 'cfg-summary__price-row');
          row.append(
            el('span', 'cfg-summary__price-label', { text: line.label }),
            el('span', 'cfg-summary__price-value', { text: line.value })
          );
          refs.summaryPriceRows.appendChild(row);
        });
      }

      updatePriceDisplay();
    }

    function isReadyForCart() {
      return !!state.photo && state.vehicle.trim().length > 0;
    }

    function canAdvanceWizard() {
      const step = WIZARD_STEPS[state.wizardStep];
      if (step.id === 'car') return isReadyForCart();
      return true;
    }

    function updateWizardNextState() {
      if (!refs.wizardNext) return;
      const canAdvance = canAdvanceWizard();
      refs.wizardNext.disabled = !canAdvance;
      refs.wizardNext.setAttribute('aria-disabled', canAdvance ? 'false' : 'true');
    }

    function cartButtonLabel() {
      if (!isReadyForCart()) {
        return `${SVG.cart} Complete all steps`;
      }
      return `${SVG.cart} Add to cart`;
    }

    function mobileBarCartLabel() {
      if (!isReadyForCart()) return `${SVG.cart} Complete all steps`;
      return `${SVG.cart} Add to cart`;
    }

    function checkoutButtonLabel() {
      if (!isReadyForCart()) return 'Checkout';
      return 'Checkout';
    }

    function setYesNo(group, value, onChange) {
      group.innerHTML = '';
      ['Yes', 'No'].forEach((v) => {
        const btn = el('button', `cfg-toggle__btn${value === v ? ' is-active' : ''}`, {
          type: 'button',
          role: 'radio',
          'aria-checked': value === v ? 'true' : 'false',
          text: v,
        });
        btn.addEventListener('click', () => onChange(v));
        group.appendChild(btn);
      });
    }

    function checkoutActionButtons() {
      return [refs.cartBtn, refs.checkoutBtn, refs.cartBtnDesktop, refs.checkoutBtnDesktop].filter(Boolean);
    }

    function updateCartButton() {
      const ready = isReadyForCart();
      checkoutActionButtons().forEach((btn) => {
        btn.disabled = !ready;
        btn.setAttribute('aria-disabled', ready ? 'false' : 'true');
        btn.classList.toggle('is-ready', ready);
        if (btn.classList.contains('cfg-wizard-bar__btn--cart')) {
          const wide = window.matchMedia('(min-width: 980px)').matches;
          btn.innerHTML = wide ? cartButtonLabel() : mobileBarCartLabel();
        } else if (btn.classList.contains('cfg-wizard-bar__btn--checkout')) {
          btn.textContent = checkoutButtonLabel();
        } else if (btn.classList.contains('cfg-cart')) {
          btn.innerHTML = cartButtonLabel();
        } else {
          btn.textContent = 'Add to cart';
        }
      });
    }

    function wizardGroup(stepId, ...nodes) {
      const g = el('div', 'cfg-wizard-group', { 'data-wizard': stepId });
      nodes.forEach((n) => {
        if (n) g.appendChild(n);
      });
      return g;
    }

    function renderUpload() {
      const zone = refs.uploadZone;
      const inner = refs.uploadInner;
      zone.className = `cfg-upload${state.photo ? ' is-filled' : ''}`;
      inner.innerHTML = '';
      if (state.photo) {
        const row = el('div', 'cfg-upload__filled');
        const thumb = el('img', null, { alt: '', src: state.photo.previewUrl });
        const meta = el('div', null, { style: 'flex:1' });
        meta.append(
          el('div', null, { style: 'font-weight:600;font-size:.92rem;color:#1a1a1a', text: state.photo.name }),
          el('div', null, {
            style: 'font-size:.78rem;color:#6b7280',
            text: `${Math.round(state.photo.size / 1024)} KB · click to replace`,
          })
        );
        const clear = el('button', 'cfg-upload__clear', { type: 'button', 'aria-label': 'Remove photo', html: SVG.close });
        clear.addEventListener('click', (e) => {
          e.stopPropagation();
          if (state.photo?.previewUrl) URL.revokeObjectURL(state.photo.previewUrl);
          state.photo = null;
          renderUpload();
          updateCartButton();
          updateBadges();
          updateWizardNextState();
        });
        row.append(thumb, meta, clear);
        inner.appendChild(row);
      } else {
        inner.append(
          el('span', 'cfg-upload__icon', { html: SVG.upload }),
          (() => {
            const t = el('div', 'cfg-upload__text');
            t.append(
              el('strong', null, { text: 'Upload steering wheel photo' }),
              el('span', 'cfg-upload__formats', {
                text: 'PNG · JPG · HEIC · PDF',
              })
            );
            return t;
          })()
        );
      }
    }

    function onPhotoFile(file) {
      if (!file) return;
      if (state.photo?.previewUrl) URL.revokeObjectURL(state.photo.previewUrl);
      state.photo = {
        name: file.name,
        size: file.size,
        file,
        previewUrl: URL.createObjectURL(file),
      };
      renderUpload();
      updateCartButton();
      updateBadges();
      updateWizardNextState();
    }

    function reconcileMaterials() {
      if (materialSyncLock) return;
      materialSyncLock = true;
      try {
        const tbMats = manifest.TB_MATERIALS || [];
        if (!tbMats.length) return;

        const prevLr = state.lrMaterial;
        fillMaterialSelect(refs.tbSelect, tbMats, state.tbMaterial, onTbMaterialChange);
        fillLrMaterialSelect();
        const lrChanged = state.lrMaterial !== prevLr;

        if (lrChanged) refreshLrGrid();
        ensureValidMarkerSelection();
        if (state.markerEnabled === 'Yes') refreshMarkerGrid();
        updatePreview();
        updateBadges();
        updatePriceDisplay();
        syncMobileWizardChrome();
      } finally {
        materialSyncLock = false;
      }
    }

    function onTbMaterialChange(m) {
      if (materialSyncLock) return;
      state.tbMaterial = m;
      state.topBottom = manifest.TB[m]?.[0] || '';
      refreshTbGrid();
      ensureValidMarkerSelection();
      if (state.markerEnabled === 'Yes') refreshMarkerGrid();
      reconcileMaterials();
      updatePreview();
      updateBadges();
      preloadInChunks(
        (manifest.TB[m] || []).flatMap((n) => [url.tbThumb(m, n), url.tb(m, n)]),
        4
      );
    }

    function onLrMaterialChange(m) {
      if (materialSyncLock) return;
      if (!materialsCompatible(manifest, state.tbMaterial, m)) return;
      state.lrMaterial = m;
      state.leftRight = manifest.LR[m]?.[0] || '';
      refreshLrGrid();
      reconcileMaterials();
      updatePreview();
      updateBadges();
      preloadInChunks(
        (manifest.LR[m] || []).flatMap((n) => [url.lrThumb(m, n), url.lr(m, n)]),
        4
      );
    }

    refs.examples = {};
    function buildExample(stepId, caption) {
      const fig = el('figure', 'cfg-example');
      const frame = el('div', 'cfg-example__frame');
      const img = el('img', 'cfg-example__img', {
        alt: 'Example preview',
        loading: 'lazy',
        decoding: 'async',
      });
      const zoomBtn = el('button', 'cfg-example__zoom', {
        type: 'button',
        'aria-label': 'Enlarge example image',
      });
      zoomBtn.innerHTML = SVG.zoom;
      zoomBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        openExampleLightbox(img);
      });
      frame.append(img, zoomBtn);
      fig.append(frame);
      if (caption) fig.appendChild(el('figcaption', 'cfg-example__cap', { text: caption }));
      refs.examples[stepId] = img;
      return fig;
    }

    function bindCfgLightboxEscape() {
      if (refs.cfgLightboxEscapeBound) return;
      refs.cfgLightboxEscapeBound = true;
      document.addEventListener('keydown', (e) => {
        if (e.key !== 'Escape') return;
        if (refs.previewLightbox && !refs.previewLightbox.hidden) closePreviewLightbox();
        else if (refs.exampleLightbox && !refs.exampleLightbox.hidden) closeExampleLightbox();
      });
    }

    function ensureExampleLightbox() {
      if (refs.exampleLightbox) return;
      bindCfgLightboxEscape();
      const overlay = el('div', 'cfg-example-lightbox', {
        hidden: 'true',
        role: 'dialog',
        'aria-modal': 'true',
        'aria-label': 'Enlarged example',
      });
      const panel = el('div', 'cfg-example-lightbox__panel');
      const closeBtn = el('button', 'cfg-example-lightbox__close', {
        type: 'button',
        'aria-label': 'Close',
      });
      closeBtn.innerHTML = SVG.close;
      const bigImg = el('img', 'cfg-example-lightbox__img', { alt: '' });
      panel.append(closeBtn, bigImg);
      overlay.appendChild(panel);
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) closeExampleLightbox();
      });
      closeBtn.addEventListener('click', closeExampleLightbox);
      const host = root.closest('.cmw-cover-configurator') || root;
      host.appendChild(overlay);
      refs.exampleLightbox = overlay;
      refs.exampleLightboxImg = bigImg;
      refs.exampleLightboxClose = closeBtn;
    }

    function openExampleLightbox(img) {
      const src = img.currentSrc || img.src;
      if (!src) return;
      ensureExampleLightbox();
      refs.exampleLightboxImg.src = src;
      refs.exampleLightboxImg.alt = img.alt || 'Enlarged example';
      refs.exampleLightbox.hidden = false;
      refs.exampleLightbox.classList.add('is-open');
      document.body.classList.add('cfg-example-lightbox-open');
      refs.exampleLightboxClose.focus();
    }

    function closeExampleLightbox() {
      if (!refs.exampleLightbox) return;
      refs.exampleLightbox.hidden = true;
      refs.exampleLightbox.classList.remove('is-open');
      document.body.classList.remove('cfg-example-lightbox-open');
    }

    function syncPreviewLightboxLayers() {
      const L = refs.previewLightboxLayers;
      if (!L) return;
      const baseSrc =
        refs.previewStage?.querySelector('.cfg-pz-0')?.dataset.cfgSrc ||
        refs.previewStage?.querySelector('.cfg-pz-0')?.currentSrc ||
        url.base();
      copyLayerToLightbox(refs.previewStage?.querySelector('.cfg-pz-0'), L.base, baseSrc);
      copyLayerToLightbox(preview.tb, L.tb);
      copyLayerToLightbox(preview.lr, L.lr);
      copyLayerToLightbox(preview.marker, L.marker);
    }

    function copyLayerToLightbox(sourceImg, targetImg, srcOverride) {
      if (!targetImg) return;
      const src =
        srcOverride ||
        sourceImg?.dataset.cfgSrc ||
        sourceImg?.currentSrc ||
        sourceImg?.src ||
        '';
      if (!src) return;
      targetImg.hidden = sourceImg ? sourceImg.hidden : false;
      setLayerSrc(targetImg, src);
    }

    function ensurePreviewLightbox() {
      if (refs.previewLightbox) return;
      bindCfgLightboxEscape();
      const overlay = el('div', 'cfg-preview-lightbox', {
        hidden: 'true',
        role: 'dialog',
        'aria-modal': 'true',
        'aria-label': 'Enlarged preview',
      });
      const panel = el('div', 'cfg-preview-lightbox__panel');
      const closeBtn = el('button', 'cfg-preview-lightbox__close', {
        type: 'button',
        'aria-label': 'Close',
      });
      closeBtn.innerHTML = SVG.close;
      const bigStage = el('div', 'cfg-preview-lightbox__stage');
      const layers = {
        base: el('img', 'cfg-layer cfg-pz-0', { alt: '', decoding: 'async' }),
        tb: el('img', 'cfg-layer cfg-pz-1', { alt: '', decoding: 'async' }),
        lr: el('img', 'cfg-layer cfg-pz-2', { alt: '', decoding: 'async' }),
        marker: el('img', 'cfg-layer cfg-pz-4', { alt: '', decoding: 'async' }),
      };
      bigStage.append(layers.base, layers.tb, layers.lr, layers.marker);
      panel.append(
        closeBtn,
        bigStage,
        el('p', 'cfg-preview-lightbox__note', {
          text: 'Visual example, not actual final product',
        })
      );
      overlay.appendChild(panel);
      overlay.addEventListener('click', (e) => {
        if (e.target === overlay) closePreviewLightbox();
      });
      closeBtn.addEventListener('click', closePreviewLightbox);
      const host = root.closest('.cmw-cover-configurator') || root;
      host.appendChild(overlay);
      refs.previewLightbox = overlay;
      refs.previewLightboxLayers = layers;
      refs.previewLightboxClose = closeBtn;
    }

    function openPreviewLightbox() {
      if (!isMobileLayout()) return;
      ensurePreviewLightbox();
      syncPreviewLightboxLayers();
      refs.previewLightbox.hidden = false;
      refs.previewLightbox.classList.add('is-open');
      document.body.classList.add('cfg-preview-lightbox-open');
      refs.previewLightboxClose.focus();
    }

    function closePreviewLightbox() {
      if (!refs.previewLightbox) return;
      refs.previewLightbox.hidden = true;
      refs.previewLightbox.classList.remove('is-open');
      document.body.classList.remove('cfg-preview-lightbox-open');
    }

    const tbMatSec = section('Material choice Top & Bottom', null, 'tbMat', false, [
      buildExample('tb-mat'),
      (() => {
        const w = el('div', 'cfg-mat');
        w.append(refs.tbSelect, el('span', 'cfg-mat__chev', { html: SVG.chevron }));
        return w;
      })(),
    ]);
    const tbSec = section('Top & Bottom', null, 'tbVar', false, refs.tbGrid);
    const lrMatSec = section('Material choice Left & Right', null, 'lrMat', false, [
      buildExample('lr-mat'),
      (() => {
        const w = el('div', 'cfg-mat');
        w.append(refs.lrSelect, el('span', 'cfg-mat__chev', { html: SVG.chevron }));
        return w;
      })(),
    ]);
    const lrSec = section('Left & Right', null, 'lrVar', false, refs.lrGrid);

    function applyGridLayout() {
      refs.tbGrid.className = 'cfg-grid-sw';
      refs.lrGrid.className = 'cfg-grid-sw';
      refs.markerGrid.className = 'cfg-grid-sw';
      refs.threadGrid.className = 'cfg-grid-sw';
    }
    applyGridLayout();

    const markerToggle = el('div', 'cfg-toggle cfg-toggle--yesno', { role: 'radiogroup' });
    const markerToggleWrap = el('div', 'cfg-toggle-wrap cfg-marker-toggle-wrap');
    markerToggleWrap.appendChild(markerToggle);
    refs.markerToggleWrap = markerToggleWrap;
    const markerToggleDesktopSlot = el('div', 'cfg-marker-toggle-desktop');
    markerToggleDesktopSlot.appendChild(markerToggleWrap);
    refs.markerToggleDesktopSlot = markerToggleDesktopSlot;
    const markerToggleCenterSlot = el('div', 'cfg-marker-toggle-center');
    refs.markerToggleCenterSlot = markerToggleCenterSlot;

    refs.markerWrap.className = 'cfg-marker-options';
    refs.markerWrap.hidden = true;
    refs.markerWrap.innerHTML = '';
    refs.markerWrap.append(
      el('p', 'cfg-marker-options__label', { text: 'Choose your marker style' }),
      refs.markerGrid
    );

    const markerBlock = section(
      "12 O'Clock marker",
      'Small strip on the centre of the steering wheel',
      'marker',
      false,
      [markerToggleDesktopSlot, markerToggleCenterSlot, refs.markerWrap]
    );
    const threadBlock = section(
      'Thread choice',
      'Pick the stitching colour for your cover.',
      'thread',
      false,
      refs.threadGrid
    );

    refs.uploadInner = el('div');
    refs.uploadZone = el('div', 'cfg-upload', { role: 'button', tabindex: '0' });
    refs.uploadZone.append(refs.uploadInput, refs.uploadInner);
    refs.uploadZone.addEventListener('click', () => refs.uploadInput.click());
    refs.uploadZone.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        refs.uploadInput.click();
      }
    });
    refs.uploadZone.addEventListener('dragover', (e) => {
      e.preventDefault();
      refs.uploadZone.classList.add('is-drag');
    });
    refs.uploadZone.addEventListener('dragleave', () => refs.uploadZone.classList.remove('is-drag'));
    refs.uploadZone.addEventListener('drop', (e) => {
      e.preventDefault();
      refs.uploadZone.classList.remove('is-drag');
      onPhotoFile(e.dataTransfer.files?.[0]);
    });
    refs.uploadInput.addEventListener('change', () => onPhotoFile(refs.uploadInput.files?.[0]));

    refs.errorBox = el('p', 'cfg-error', { style: 'display:none' });
    refs.cartBtn = el('button', 'cfg-wizard-bar__btn cfg-wizard-bar__btn--cart', {
      type: 'button',
      disabled: 'true',
      'aria-disabled': 'true',
      hidden: 'true',
    });
    refs.cartBtn.innerHTML = mobileBarCartLabel();

    refs.checkoutBtn = el('button', 'cfg-wizard-bar__btn cfg-wizard-bar__btn--checkout', {
      type: 'button',
      disabled: 'true',
      'aria-disabled': 'true',
      hidden: 'true',
      text: 'Checkout',
    });

    const onCheckoutAction = async (destination) => {
      if (!isReadyForCart()) return;
      const btns = checkoutActionButtons();
      refs.errorBox.style.display = 'none';
      if (isDesignMode(config)) {
        refs.errorBox.textContent =
          'Add to cart is not available in the theme editor. Use View on your store to test checkout.';
        refs.errorBox.style.display = 'block';
        return;
      }
      btns.forEach((b) => {
        b.classList.add('is-loading');
        b.disabled = true;
      });
      try {
        await addToCart(config, state, manifest, cartProduct, { destination });
        document.dispatchEvent(
          new CustomEvent('cmw:cart:added', { detail: { destination } })
        );
      } catch (err) {
        refs.errorBox.textContent = err.message || 'Could not add to cart.';
        refs.errorBox.style.display = 'block';
        updateCartButton();
      } finally {
        btns.forEach((b) => b.classList.remove('is-loading'));
        updateCartButton();
      }
    };
    refs.cartBtn.addEventListener('click', () => onCheckoutAction('cart'));
    refs.checkoutBtn.addEventListener('click', () => onCheckoutAction('checkout'));

    const vehicleInputId = `cfg-vehicle-${config.sectionId}`;
    const vehicleInput = el('input', 'cfg-field__input', {
      type: 'text',
      id: vehicleInputId,
      name: 'your_car',
      required: 'required',
      autocomplete: 'off',
      placeholder: 'e.g. BMW 3 Series 2018',
      'aria-label': 'Make, model and year',
    });
    vehicleInput.addEventListener('input', () => {
      state.vehicle = vehicleInput.value;
      updateBadges();
      updateCartButton();
      updateWizardNextState();
      syncMobileWizardChrome();
    });

    const carSec = el('section', 'cfg-sec cfg-sec--car');
    const carFieldLabel = el('label', 'cfg-field__label', { for: vehicleInputId });
    carFieldLabel.append(document.createTextNode('Make, model and year '));
    carFieldLabel.appendChild(el('span', 'cfg-sec__req', { text: 'Required' }));
    const carField = el('div', 'cfg-field');
    carField.append(
      carFieldLabel,
      vehicleInput,
      el('p', 'cfg-field__hint', { text: 'Example: Audi A4 2019, Ford Mustang 2021' })
    );
    carSec.append(carField);

    const photoSec = section(
      'Photo of your steering wheel',
      null,
      'photo',
      true,
      refs.uploadZone
    );
    photoSec.classList.add('cfg-sec--photo');

    const paddleToggle = el('div', 'cfg-toggle cfg-toggle--yesno', {
      role: 'radiogroup',
      'aria-label': 'Does your car have paddle shifters?',
    });
    refs.paddleToggle = paddleToggle;
    const paddleRow = el('div', 'cfg-paddle-row');
    paddleRow.append(
      el('p', 'cfg-paddle-row__label', { text: 'Does your car have paddle shifters?' }),
      paddleToggle
    );

    function bindPaddleToggle() {
      setYesNo(paddleToggle, state.paddleShifters, (v) => {
        state.paddleShifters = v;
        bindPaddleToggle();
        updateBadges();
        updateSummary();
        syncMobileWizardChrome();
        requestAnimationFrame(syncMobileLayoutInsets);
      });
    }

    const carStack = el('div', 'cfg-car-stack');
    carStack.append(paddleRow, carSec, photoSec);

    const materialsStep = el('div', 'cfg-step', {
      'data-cfg-step': 'materials',
      id: `cfg-step-materials-${config.sectionId}`,
    });
    materialsStep.append(
      wizardGroup('tb-mat', tbMatSec),
      wizardGroup('tb-sw', tbSec),
      wizardGroup('lr-mat', lrMatSec),
      wizardGroup('lr-sw', lrSec)
    );

    const detailsStep = el('div', 'cfg-step', {
      'data-cfg-step': 'details',
      id: `cfg-step-details-${config.sectionId}`,
    });
    detailsStep.append(wizardGroup('marker', markerBlock), wizardGroup('thread', threadBlock));

    const summarySec = el('section', 'cfg-sec cfg-sec--summary');
    const summaryHead = el('header', 'cfg-summary__head');
    summaryHead.appendChild(el('h3', 'cfg-summary__title', { text: 'Your configuration' }));
    refs.summaryTotal = el('p', 'cfg-summary__total', { text: '' });
    refs.summaryPriceRows = el('div', 'cfg-summary__price-breakdown');
    summarySec.append(summaryHead, refs.summaryTotal, refs.summaryPriceRows);
    const summaryBody = el('div', 'cfg-summary__body');
    refs.summaryRows = el('div', 'cfg-summary__rows');
    refs.summaryCarBlock = el('div', 'cfg-summary__car-block');
    refs.summaryPhotoBlock = el('div', 'cfg-summary__photo-block');
    summaryBody.append(refs.summaryRows, refs.summaryCarBlock, refs.summaryPhotoBlock);
    summarySec.appendChild(summaryBody);

    const carStep = el('div', 'cfg-step', {
      'data-cfg-step': 'car',
      id: `cfg-step-car-${config.sectionId}`,
    });
    carStep.append(wizardGroup('car', carStack));
    carStep.hidden = true;

    const summaryStep = el('div', 'cfg-step', {
      'data-cfg-step': 'summary',
      id: `cfg-step-summary-${config.sectionId}`,
    });
    summaryStep.append(wizardGroup('summary', summarySec, refs.errorBox));
    summaryStep.hidden = true;
    detailsStep.hidden = true;

    const panel = el('div', 'cfg-panel');

    const stage = el('div', 'cfg-stage cfg-preview__stage');
    refs.previewStage = stage;
    stage.append(
      el('img', 'cfg-layer cfg-pz-0', { alt: '', decoding: 'async', fetchpriority: 'high', src: url.base() }),
      preview.tb,
      preview.lr,
      preview.marker
    );
    const previewFrame = el('div', 'cfg-preview__frame');
    const previewZoom = el('button', 'cfg-preview__zoom cfg-mobile-only', {
      type: 'button',
      'aria-label': 'Enlarge preview',
    });
    previewZoom.innerHTML = SVG.zoom;
    previewZoom.addEventListener('click', (e) => {
      e.stopPropagation();
      openPreviewLightbox();
    });
    stage.addEventListener('click', () => {
      if (isMobileLayout()) openPreviewLightbox();
    });
    previewFrame.append(stage, previewZoom);
    refs.previewDots = el('div', 'cfg-preview__dots cfg-mobile-only', {
      role: 'tablist',
      'aria-label': 'Configuration steps',
    });
    WIZARD_STEPS.forEach((st, i) => {
      const dot = el('button', 'cfg-preview__dot', {
        type: 'button',
        'data-dot': String(i),
        'aria-label': `Step ${i + 1}: ${st.title}`,
      });
      dot.addEventListener('click', () => {
        state.wizardStep = i;
        updateWizardUI({ resetScroll: true });
      });
      refs.previewDots.appendChild(dot);
    });
    refs.previewLive = el('div', 'cfg-preview__live cfg-mobile-only', {
      'aria-live': 'polite',
      hidden: 'true',
    });
    const previewBox = el('div', 'cfg-preview');
    previewBox.append(previewFrame, refs.previewDots, refs.previewLive, preview.chips);

    const progressNav = el('nav', 'cfg-progress cfg-desktop-only', { 'aria-label': 'Configuration progress' });
    refs.progressItems = WIZARD_STEPS.map((st, i) => {
      const item = el('button', 'cfg-progress__item', {
        type: 'button',
        'data-step-index': String(i),
        'aria-label': `Step ${i + 1}: ${st.title}`,
      });
      item.append(
        el('span', 'cfg-progress__num', { text: String(i + 1) }),
        el('span', 'cfg-progress__label', { text: st.short || st.title })
      );
      item.addEventListener('click', () => {
        state.wizardStep = i;
        updateWizardUI({ resetScroll: true });
      });
      progressNav.appendChild(item);
      return item;
    });

    const configuratorHost = root.closest('.cmw-cover-configurator') || root;

    function closeWizardInfo() {
      if (!refs.wizardInfoBtn || !refs.wizardInfoPopover) return;
      refs.wizardInfoBtn.setAttribute('aria-expanded', 'false');
      refs.wizardInfoPopover.hidden = true;
      refs.wizardInfoPopover.innerHTML = '';
      refs.wizardInfoPopover.removeAttribute('style');
    }

    function positionWizardInfoPopover() {
      if (!refs.wizardInfoBtn || !refs.wizardInfoPopover || refs.wizardInfoPopover.hidden) return;
      const btn = refs.wizardInfoBtn.getBoundingClientRect();
      const pop = refs.wizardInfoPopover;
      const gap = 10;
      const width = Math.min(340, window.innerWidth - 24);
      pop.style.width = `${width}px`;
      pop.style.left = 'auto';
      pop.style.right = `${Math.max(12, window.innerWidth - btn.right)}px`;
      let top = btn.bottom + gap;
      pop.style.top = `${top}px`;
      const popRect = pop.getBoundingClientRect();
      if (popRect.bottom > window.innerHeight - 12) {
        top = Math.max(12, btn.top - popRect.height - gap);
        pop.style.top = `${top}px`;
      }
    }

    function openWizardInfo(text) {
      if (!refs.wizardInfoBtn || !refs.wizardInfoPopover || !text) return;
      refs.wizardInfoPopover.innerHTML = '';
      refs.wizardInfoPopover.append(
        el('p', 'cfg-info-popover__kicker', { text: 'About this step' }),
        el('p', 'cfg-info-popover__text', { text })
      );
      refs.wizardInfoPopover.hidden = false;
      refs.wizardInfoBtn.setAttribute('aria-expanded', 'true');
      requestAnimationFrame(positionWizardInfoPopover);
    }

    function toggleWizardInfo() {
      const step = WIZARD_STEPS[state.wizardStep];
      if (!step.info) return;
      if (!refs.wizardInfoPopover.hidden) {
        closeWizardInfo();
        return;
      }
      openWizardInfo(step.info);
    }

    const wizardHead = el('div', 'cfg-wizard-head');
    const wizardHeadRow = el('div', 'cfg-wizard-head__row');
    refs.wizardTitle = el('h2', 'cfg-wizard-head__title', { text: WIZARD_STEPS[0].title });
    const wizardInfoWrap = el('div', 'cfg-wizard-head__info-wrap');
    refs.wizardInfoBtn = el('button', 'cfg-wizard-head__info', {
      type: 'button',
      hidden: 'true',
      'aria-label': 'More information',
      'aria-expanded': 'false',
    });
    refs.wizardInfoBtn.innerHTML = SVG.info;
    refs.wizardInfoPopover = el('div', 'cfg-info-popover', {
      role: 'dialog',
      'aria-label': 'Step information',
      hidden: 'true',
    });
    configuratorHost.appendChild(refs.wizardInfoPopover);
    refs.wizardInfoBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      const step = WIZARD_STEPS[state.wizardStep];
      const exampleImg = refs.examples[step.id];
      if (exampleSideForStep(step.id) && exampleImg) {
        closeWizardInfo();
        openExampleLightbox(exampleImg);
        return;
      }
      toggleWizardInfo();
    });
    wizardInfoWrap.append(refs.wizardInfoBtn);
    refs.markerToggleMobileSlot = el('div', 'cfg-wizard-head__marker-toggle');
    wizardHeadRow.append(refs.wizardTitle, wizardInfoWrap, refs.markerToggleMobileSlot);
    refs.wizardSelection = el('p', 'cfg-wizard-head__sel', { text: '' });
    refs.wizardHint = el('p', 'cfg-wizard-head__hint', { text: WIZARD_STEPS[0].hint || '' });
    wizardHead.append(wizardHeadRow, refs.wizardSelection, refs.wizardHint);

    document.addEventListener('click', (e) => {
      if (refs.wizardInfoPopover?.hidden) return;
      if (e.target.closest('.cfg-wizard-head__info') || e.target.closest('.cfg-info-popover')) {
        return;
      }
      closeWizardInfo();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && refs.wizardInfoPopover && !refs.wizardInfoPopover.hidden) {
        closeWizardInfo();
      }
    });

    const wizardViewport = el('div', 'cfg-wizard-viewport');
    const wizardBar = el('nav', 'cfg-wizard-bar', { 'aria-label': 'Step navigation' });
    refs.wizardPrev = el('button', 'cfg-wizard-bar__btn cfg-wizard-bar__btn--prev', {
      type: 'button',
      'aria-label': 'Previous step',
    });
    refs.wizardPrev.innerHTML = SVG.arrowL;
    refs.wizardNext = el('button', 'cfg-wizard-bar__btn cfg-wizard-bar__btn--next', {
      type: 'button',
      'aria-label': 'Next step',
    });
    refs.wizardNext.innerHTML = `<span class="cfg-wizard-bar__btn-label">Next</span>${SVG.arrowR}`;
    refs.wizardCount = el('span', 'cfg-wizard-bar__count', { text: 'Step 1 of 8' });
    refs.wizardActions = el('div', 'cfg-wizard-bar__actions');
    refs.wizardActions.append(refs.cartBtn, refs.checkoutBtn);
    wizardBar.append(refs.wizardPrev, refs.wizardCount, refs.wizardNext, refs.wizardActions);

    const wizardCol = el('div', 'cfg-wizard-col');
    refs.wizardCol = wizardCol;
    wizardViewport.appendChild(panel);
    panel.append(materialsStep, detailsStep, carStep, summaryStep);
    panel.querySelectorAll('.cfg-wizard-group').forEach((g, i) => {
      g.hidden = i !== 0;
    });

    refs.scrollHint = el('button', 'cfg-scroll-hint', {
      type: 'button',
      hidden: 'true',
      'aria-label': 'Scroll for more options',
    });
    refs.scrollHint.innerHTML =
      '<span class="cfg-scroll-hint__label">More options</span>' +
      '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>';
    refs.scrollHint.addEventListener('click', () => {
      wizardViewport.scrollBy({ top: wizardViewport.clientHeight * 0.8, behavior: 'smooth' });
    });

    const previewAside = el('aside', 'cfg-side', { 'aria-label': 'Live preview' }, [previewBox]);
    wizardCol.append(wizardHead, wizardViewport, wizardBar, refs.scrollHint);

    const grid = el('div', 'cfg-grid cfg-app');
    grid.append(previewAside, wizardCol);

    const topbar = el('header', 'cfg-topbar cfg-mobile-only');
    const topbarMeta = el('div', 'cfg-topbar__meta');
    refs.priceEl = el('p', 'cfg-topbar__price', { text: config.productPrice || '' });
    const topbarTitle = config.productTitle || 'Custom cover';
    topbarMeta.append(el('h1', 'cfg-topbar__title', { text: topbarTitle }), refs.priceEl);
    refs.mobileProgress = el('div', 'cfg-mobile-progress', { 'aria-hidden': 'true' });
    refs.mobileProgressFill = el('span', 'cfg-mobile-progress__fill');
    refs.mobileProgress.appendChild(refs.mobileProgressFill);
    refs.mobileStepInfo = el('div', 'cfg-topbar__step');
    refs.mobileStepLabel = el('span', 'cfg-topbar__step-label', { text: '' });
    refs.mobileStepCount = el('span', 'cfg-topbar__step-count', { text: '' });
    refs.mobileStepInfo.append(refs.mobileStepLabel, refs.mobileStepCount);
    topbar.append(topbarMeta, refs.mobileStepInfo, refs.mobileProgress);

    const hero = el('header', 'cfg-hero cfg-desktop-only', null, [
      (() => {
        const h = el('h1');
        h.innerHTML = 'Build your <em>cover.</em>';
        return h;
      })(),
      el('p', null, {
        text: 'Pick materials, thread, and marker. Then add your car, photo, and review your configuration.',
      }),
      (() => {
        refs.heroPrice = el('p', 'cfg-hero__price', { text: config.productPrice || '' });
        return refs.heroPrice;
      })(),
    ]);

    main.append(loadStatus, topbar, hero, progressNav, grid);

    function placeMarkerToggle() {
      if (
        !refs.markerToggleWrap ||
        !refs.markerToggleMobileSlot ||
        !refs.markerToggleDesktopSlot ||
        !refs.markerToggleCenterSlot
      ) {
        return;
      }
      const onMarkerStep = WIZARD_STEPS[state.wizardStep]?.id === 'marker';
      if (onMarkerStep) {
        main.dataset.cfgMarkerYes = state.markerEnabled === 'Yes' ? '1' : '0';
      }
      let slot;
      if (!isMobileLayout()) {
        slot = refs.markerToggleDesktopSlot;
      } else if (onMarkerStep && state.markerEnabled === 'Yes') {
        slot = refs.markerToggleMobileSlot;
      } else if (onMarkerStep) {
        slot = refs.markerToggleCenterSlot;
      } else {
        slot = refs.markerToggleDesktopSlot;
      }
      if (refs.markerToggleWrap.parentElement !== slot) {
        slot.appendChild(refs.markerToggleWrap);
      }
    }

    function syncMobileLayoutInsets() {
      if (!isMobileLayout()) {
        configuratorHost.style.removeProperty('--cfg-mobile-dock-h');
        configuratorHost.style.removeProperty('--cfg-mobile-topbar-h');
        return;
      }
      const topH = Math.ceil(topbar.getBoundingClientRect().height);
      if (topH > 0) {
        configuratorHost.style.setProperty('--cfg-mobile-topbar-h', `${topH}px`);
      }
      if (refs.wizardCol) {
        const dockH = Math.ceil(refs.wizardCol.getBoundingClientRect().height);
        if (dockH > 0) {
          configuratorHost.style.setProperty('--cfg-mobile-dock-h', `${dockH}px`);
        }
      }
    }

    function updateWizardUI({ resetScroll = false } = {}) {
      const step = WIZARD_STEPS[state.wizardStep];
      const matIds = ['tb-mat', 'tb-sw', 'lr-mat', 'lr-sw'];
      const detIds = ['marker', 'thread'];
      materialsStep.hidden = !matIds.includes(step.id);
      detailsStep.hidden = !detIds.includes(step.id);
      carStep.hidden = step.id !== 'car';
      summaryStep.hidden = step.id !== 'summary';
      main.dataset.cfgWizardStep = step.id;
      if (step.id === 'marker') {
        main.dataset.cfgMarkerYes = state.markerEnabled === 'Yes' ? '1' : '0';
      } else {
        delete main.dataset.cfgMarkerYes;
      }
      main.querySelectorAll('.cfg-wizard-group').forEach((g) => {
        g.hidden = g.dataset.wizard !== step.id;
      });
      const stepNum = state.wizardStep + 1;
      const total = WIZARD_STEPS.length;
      refs.wizardCount.textContent = `Step ${stepNum} of ${total}`;
      if (refs.mobileStepLabel) {
        const hideMobileStepLabel = step.id === 'car' || step.id === 'summary';
        refs.mobileStepLabel.textContent = hideMobileStepLabel ? '' : step.short || step.title;
        refs.mobileStepLabel.hidden = hideMobileStepLabel;
      }
      if (refs.mobileStepCount) refs.mobileStepCount.textContent = `Step ${stepNum} of ${total}`;
      if (refs.mobileProgressFill) {
        refs.mobileProgressFill.style.width = `${(stepNum / total) * 100}%`;
      }
      const isLastStep = state.wizardStep === total - 1;
      refs.wizardPrev.disabled = state.wizardStep === 0;
      refs.wizardNext.hidden = isLastStep;
      refs.wizardCount.hidden = isLastStep;
      refs.cartBtn.hidden = !isLastStep;
      refs.checkoutBtn.hidden = !isLastStep;
      if (refs.wizardActions) refs.wizardActions.hidden = !isLastStep;
      if (refs.cartBtnDesktop) refs.cartBtnDesktop.hidden = !isLastStep;
      if (refs.checkoutBtnDesktop) refs.checkoutBtnDesktop.hidden = !isLastStep;
      wizardBar.classList.toggle('cfg-wizard-bar--summary', isLastStep);
      updateWizardNextState();
      syncWizardChrome();
      refreshExampleImages();
      if (resetScroll) wizardViewport.scrollTop = 0;
      if (step.id === 'marker' && state.markerEnabled === 'Yes') refreshMarkerGrid();
      if (step.id === 'summary') updateSummary();
      preloadInChunks(urlsForWizardStep(step.id), 12);
      closeWizardInfo();
      updateScrollHint();
      placeMarkerToggle();
      requestAnimationFrame(() => {
        syncMobileLayoutInsets();
        if (step.id === 'car' || step.id === 'summary') {
          requestAnimationFrame(syncMobileLayoutInsets);
        }
      });
    }

    function activeStepItemCount() {
      const step = WIZARD_STEPS[state.wizardStep];
      switch (step.id) {
        case 'tb-sw':
          return manifest.TB[state.tbMaterial]?.length || 0;
        case 'lr-sw':
          return manifest.LR[state.lrMaterial]?.length || 0;
        case 'marker':
          return state.markerEnabled === 'Yes' ? markersForState(manifest, state).length : 0;
        case 'thread':
          return manifest.THREAD_OPTIONS.length;
        default:
          return 0;
      }
    }

    function updateScrollHint() {
      if (!refs.scrollHint) return;
      const isDesktop = !isMobileLayout();
      const count = activeStepItemCount();
      const overflows =
        wizardViewport.scrollHeight - wizardViewport.clientHeight > 4;
      const atBottom =
        wizardViewport.scrollTop + wizardViewport.clientHeight >=
        wizardViewport.scrollHeight - 4;
      const threshold = isDesktop ? 12 : 8;
      const show = count > threshold && overflows && !atBottom;
      refs.scrollHint.hidden = !show;
      refs.scrollHint.classList.toggle('is-visible', show);
      refs.scrollHint.classList.toggle('cfg-scroll-hint--mobile', !isDesktop);
    }

    const _updateBadges = updateBadges;
    updateBadges = () => {
      _updateBadges();
      syncWizardChrome();
      updateScrollHint();
    };

    refs.wizardPrev.addEventListener('click', () => {
      if (state.wizardStep > 0) {
        state.wizardStep -= 1;
        updateWizardUI({ resetScroll: true });
      }
    });
    refs.wizardNext.addEventListener('click', () => {
      if (!canAdvanceWizard()) return;
      if (state.wizardStep < WIZARD_STEPS.length - 1) {
        state.wizardStep += 1;
        updateWizardUI({ resetScroll: true });
      }
    });

    window.matchMedia('(max-width: 979px)').addEventListener('change', () => {
      applyGridLayout();
      placeMarkerToggle();
      state.wizardStep = 0;
      updateWizardUI({ resetScroll: true });
    });

    shell.appendChild(main);

    function bindMarkerToggle() {
      setYesNo(markerToggle, state.markerEnabled, (v) => {
        state.markerEnabled = v;
        refs.markerWrap.hidden = v !== 'Yes';
        if (v === 'Yes') refreshMarkerGrid();
        updatePreview();
        updateBadges();
        bindMarkerToggle();
        placeMarkerToggle();
        requestAnimationFrame(syncMobileLayoutInsets);
      });
    }
    bindMarkerToggle();
    placeMarkerToggle();
    bindPaddleToggle();

    reconcileMaterials();
    refreshTbGrid();
    refreshLrGrid();
    renderThreadSwatches();

    wizardViewport.addEventListener('scroll', updateScrollHint, { passive: true });
    let resizeRaf = 0;
    const onResize = () => {
      if (resizeRaf) return;
      resizeRaf = window.requestAnimationFrame(() => {
        resizeRaf = 0;
        updateScrollHint();
        updateCartButton();
        placeMarkerToggle();
        updateSummary();
        syncMobileLayoutInsets();
      });
    };
    window.addEventListener('resize', onResize, { passive: true });
    window.addEventListener(
      'resize',
      () => {
        if (refs.wizardInfoPopover && !refs.wizardInfoPopover.hidden) {
          positionWizardInfoPopover();
        }
      },
      { passive: true }
    );
    setTimeout(updateScrollHint, 300);
    renderUpload();
    updatePreview();
    updateBadges();
    updateCartButton();
    updatePriceDisplay();
    updateWizardUI({ resetScroll: true });

    const allUrls = collectImageUrls(manifest, assetBase, assetQuery);

    function finishLoading() {
      main.classList.remove('cfg-is-loading');
      main.removeAttribute('aria-busy');
      loadStatus.textContent = '';
      requestAnimationFrame(() => {
        syncMobileLayoutInsets();
        requestAnimationFrame(syncMobileLayoutInsets);
      });
    }

    const criticalUrls = [
      url.base(),
      url.tb(state.tbMaterial, state.topBottom),
      url.lr(state.lrMaterial, state.leftRight),
    ];

    Promise.race([
      preloadImages(criticalUrls),
      new Promise((resolve) => setTimeout(resolve, 5000)),
    ]).finally(() => {
      finishLoading();
      const currentTbVariants = (manifest.TB[state.tbMaterial] || []).map((n) =>
        url.tb(state.tbMaterial, n)
      );
      const currentLrVariants = (manifest.LR[state.lrMaterial] || []).map((n) =>
        url.lr(state.lrMaterial, n)
      );
      preloadInChunks(urlsForWizardStep(WIZARD_STEPS[state.wizardStep].id), 12);
      preloadInChunks([...currentTbVariants, ...currentLrVariants], 8);
      const rest = allUrls.filter((u) => !PRELOADED_URLS.has(u));
      preloadInChunks(rest, 8);
    });

    const refreshPricing = async () => {
      await resolveCurrencyContext(config, cartProduct);
      updatePriceDisplay();
      if (refs.tbSelect) {
        const tbMats = manifest.TB_MATERIALS || [];
        fillMaterialSelect(refs.tbSelect, tbMats, state.tbMaterial, onTbMaterialChange);
        fillLrMaterialSelect();
      }
      updateSummary();
    };

    document.addEventListener('shopify:currency:changed', refreshPricing);

    return { refreshPricing };
  }

  async function initFromSection(sectionEl) {
    const dataEl = sectionEl.querySelector('[data-cmw-cover-config]');
    if (!dataEl) return;
    const config = JSON.parse(dataEl.textContent);
    const app = sectionEl.querySelector('[data-cmw-cover-app]');
    if (!app) return;

    const [manifest, cartProduct] = await Promise.all([
      fetch(config.manifestUrl).then((r) => {
        if (!r.ok) throw new Error('Could not load configurator data.');
        return r.json();
      }),
      loadCartProduct(config),
    ]);

    await resolveCurrencyContext(config, cartProduct);

    // Preview layers use PNG unless you uploaded matching .webp files for every layer.
    if (config.preferWebp === true) {
      const webpOk = await probeWebp(config.assetBase, config.assetQuery || '');
      if (webpOk) ASSET_EXT.value = '.webp';
    }

    if (!config.assetBase) {
      console.error('[CMW configurator] assetBase missing — check cmw-cfg__Base.png is in theme assets.');
    }

    buildConfigurator(app, config, manifest, cartProduct);
  }

  function boot() {
    document.querySelectorAll('[data-cmw-cover-configurator]').forEach(initFromSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  window.CMWCoverConfigurator = { init: initFromSection, boot };
})();
